import { Menu } from '@syncfusion/ej2-navigations';

let reportMenuInstance = null;
let reportMenuWrapper = null;

export const openReportsMenu = ({ target, grid, items, onClick }) => {

  closeReportsMenu();

  // Wrapper
  reportMenuWrapper = document.createElement('div');
  reportMenuWrapper.style.position = 'absolute';
  reportMenuWrapper.style.background = '#fff';
  reportMenuWrapper.style.border = '1px solid #ccc';
  reportMenuWrapper.style.boxShadow = '0 2px 8px rgba(75, 67, 67, 0.15)';
  reportMenuWrapper.style.zIndex = '9999';
  reportMenuWrapper.style.minWidth = '200px';
  reportMenuWrapper.style.maxHeight = '300px';
  reportMenuWrapper.style.overflowY = 'auto';
  reportMenuWrapper.style.borderRadius = '6px';

  // Header
  const header = document.createElement('div');
  header.style.display = 'flex';
  header.style.justifyContent = 'space-between';
  header.style.padding = '6px 10px';
  header.style.borderBottom = '1px solid #eee';
  header.style.fontWeight = 'bold';
  header.style.position = 'sticky';
  header.style.top = '0';
  
  header.style.background = '#fff';

  header.innerText = "Reports";

  const closeBtn = document.createElement('span');
  closeBtn.innerHTML = '✖';
  closeBtn.style.cursor = 'pointer';
  closeBtn.style.color = 'red';

  closeBtn.onclick = () => closeReportsMenu();

  header.appendChild(closeBtn);

  const menuDiv = document.createElement('ul');

  reportMenuWrapper.appendChild(header);
  reportMenuWrapper.appendChild(menuDiv);
  document.body.appendChild(reportMenuWrapper);

  // Menu
  reportMenuInstance = new Menu({
    items,
    select: async (args) => {
        if (args.item.disabled) return; // 🔥 prevent click

      await onClick(args.item.id);
    }
  });

  reportMenuInstance.appendTo(menuDiv);
// 🔥 IMPORTANT FIX
items.forEach(item => {
    if (item.disabled && item.id) {
      reportMenuInstance.enableItems([item.text], false); 
    }
  });
  // Position fix
  const rect = target.getBoundingClientRect();
  const screenWidth = window.innerWidth;

  let left = rect.left - 300;
  const menuWidth = 200;

  if(rect.left + menuWidth > screenWidth) {
    left = screenWidth - menuWidth - 200;
  }
  reportMenuWrapper.style.left = left + 'px';
  reportMenuWrapper.style.top = rect.bottom + 'px';
};

export const closeReportsMenu = () => {
  if (reportMenuInstance) {
    reportMenuInstance.destroy();
    reportMenuInstance = null;
  }

  if (reportMenuWrapper) {
    reportMenuWrapper.remove();
    reportMenuWrapper = null;
  }
};

export const setMenuLoading = (id, loading, menuItemsMap) => {
  const items = reportMenuInstance?.items;
  if (!items) return;
  
  const item = items.find(x => x.id === id);
  if (!item) return;

  item.text = loading ? "Loading..." : menuItemsMap[id];
  reportMenuInstance.refresh();
  items.forEach(item => {
    if (item.disabled && item.id) {
      reportMenuInstance.enableItems([item.text], false); 
    }
  });
};